import { SET_TIMESLOTS, RESET_TIMESLOTS } from "../actions/timeslots";

const initialState = [];

const timeslots = (state = initialState, action) => {
  switch (action.type) {
    case SET_TIMESLOTS:
      return [ ...action.payload ];
    case RESET_TIMESLOTS:
    return initialState;
    default:
      return state;
  }
};

export default timeslots;



// WEBPACK FOOTER //
// ./src/store/reducers/timslots.js